'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: space-between;\n  flex: 1;\n  ", ";\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: space-between;\n  flex: 1;\n  ", ";\n"])), function (_a) {
    var isCheckoutDesktop = _a.isCheckoutDesktop;
    return (isCheckoutDesktop ? 'padding: 0;' : 'padding: 30px 0 0 0;');
});
var DoublePane = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 50px;\n  @media only screen and (max-width: ", "px) {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  ", ";\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 50px;\n  @media only screen and (max-width: ", "px) {\n    grid-template-columns: 1fr;\n    gap: 20px;\n  }\n  ",
    ";\n"])), function (_a) {
    var breakPoint = _a.breakPoint;
    return breakPoint;
}, function (_a) {
    var isCheckoutDesktop = _a.isCheckoutDesktop, rightColumnWidth = _a.rightColumnWidth, breakPoint = _a.breakPoint;
    return (isCheckoutDesktop
        ? "grid-template-columns: 1fr " + rightColumnWidth + "px; @media only screen and (max-width: " + breakPoint + "px) {\n      grid-template-columns: 1fr " + rightColumnWidth + "px;\n      gap: 50px;\n    }"
        : 'grid-template-columns: 1fr 1fr;');
});
var ButtonContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-self: flex-end;\n  @media only screen and (max-width: ", "px) {\n    flex-direction: column;\n    background: ", ";\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    width: calc(100% - 30px);\n    ", ";\n    padding: 10px 15px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-self: flex-end;\n  @media only screen and (max-width: ", "px) {\n    flex-direction: column;\n    background: ", ";\n    position: fixed;\n    right: 0;\n    bottom: 0;\n    width: calc(100% - 30px);\n    ", ";\n    padding: 10px 15px;\n  }\n"])), function (_a) {
    var breakPoint = _a.breakPoint;
    return breakPoint;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$white;
}, function (_a) {
    var isButtonLabelVisible = _a.isButtonLabelVisible;
    return (isButtonLabelVisible ? 'height: auto;' : 'height: 48px;');
});
var RightPane = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  @media only screen and (max-width: ", "px) {\n    height: 72vh;\n  }\n  ", ";\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ::-webkit-scrollbar {\n    width: 8px;\n    background: ", ";\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 4px;\n  }\n"], ["\n  @media only screen and (max-width: ", "px) {\n    height: 72vh;\n  }\n  ",
    ";\n  overflow-y: auto;\n  overflow-x: hidden;\n\n  ::-webkit-scrollbar {\n    width: 8px;\n    background: ", ";\n  }\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n    border-radius: 4px;\n  }\n"])), function (_a) {
    var breakPoint = _a.breakPoint;
    return breakPoint;
}, function (_a) {
    var isCheckoutDesktop = _a.isCheckoutDesktop, breakPoint = _a.breakPoint;
    return (isCheckoutDesktop
        ? "height: 734px;\n  @media only screen and (max-width: " + breakPoint + "px) {\n    height: 734px;\n  }\n  "
        : 'height: 400px;');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.$greyDark;
});
var LeftPane = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject([""], [""])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;

exports.ButtonContainer = ButtonContainer;
exports.Container = Container;
exports.DoublePane = DoublePane;
exports.LeftPane = LeftPane;
exports.RightPane = RightPane;
